import InstantBookingModal from './InstantBookingModal';

export default InstantBookingModal;
